document.addEventListener("DOMContentLoaded", () => {
  const hasTextAnimation =
    document.querySelector(".text-item") ||
    document.querySelector(".rotated-item");

  const animateTextColumns = () => {
    if (!hasTextAnimation || typeof gsap === "undefined") return;

    const tl = gsap.timeline();

    tl.to(".text-item", {
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      duration: 0.8,
      ease: "power2.out",
      stagger: {
        amount: 3,
        from: "start",
      },
    }).to(
      ".rotated-item",
      {
        opacity: 1,
        filter: "blur(0px)",
        duration: 0.8,
        ease: "power2.out",
        stagger: 0.2,
      },
      "-=2",
    );
  };

  if (hasTextAnimation) {
    setTimeout(animateTextColumns, 200);
  }

  const section = document.querySelector(".image-cursor-trail-section");
  const container = section.querySelector(".hero-section");
  const speedIndicator = document.querySelector(".speed-indicator");
  const isMobile =
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ||
    window.innerWidth <= 768;

  const config = {
    imageCount: 14,
    imageLifespan: 1400,
    removalDelay: 30,
    mouseThreshold: isMobile ? 55 : 160,
    scrollThreshold: 90,
    touchImageInterval: 150,
    minMovementForImage: isMobile ? 8 : 16,
    inDuration: 700,
    outDuration: 1100,
    inEasing: "cubic-bezier(.07,.5,.5,1)",
    outEasing: "cubic-bezier(.87, 0, .13, 1)",
    baseImageSize: isMobile ? 220 : 320,
    minImageSize: isMobile ? 180 : 240,
    maxImageSize: isMobile ? 320 : 460,
    baseRotation: 20,
    maxRotationFactor: 2.2,
    speedSmoothingFactor: 0.2,
    showSpeedIndicator: false,
    staggerRange: 70,
    easing: {
      scale: "cubic-bezier(0.34, 1.56, 0.64, 1)",
      reveal: "cubic-bezier(0.87, 0, 0.13, 1)",
    },
  };

  const imagesDataElement = container.querySelector(".trail-images-data");

  let images = [];

  if (imagesDataElement) {
    try {
      images = JSON.parse(imagesDataElement.textContent.trim());
    } catch (error) {
      console.error("Cursor trail images JSON error:", error);
    }
  }

  if (!images.length) {
    console.warn("Cursor trail: no images added in section settings.");
    return;
  }

  const PATTERNS = {
    flame: {
      name: "Flame Trail",
      create: () => null,
      revealTiming: () => 0,
      collapseTiming: () => 0,
    },

    zoomfade: {
      name: "Zoom Fade",
      create: () => null,
      revealTiming: () => 0,
      collapseTiming: () => 0,
    },

    venetian: {
      name: "Venetian Blinds",
      create: (container, imageSrc, size) => {
        const fragments = [];
        const stripCount = 12;
        const stripHeight = 100 / stripCount;

        for (let i = 0; i < stripCount; i++) {
          const fragment = document.createElement("div");
          fragment.className = "image-fragment";

          const bg = document.createElement("div");
          bg.className = "fragment-bg";
          bg.style.backgroundImage = `url(${imageSrc})`;

          const y = i * stripHeight;

          fragment.style.cssText = `
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transform: translate3d(0, 0, 0) rotateX(90deg);
            transform-origin: 50% ${y + stripHeight / 2}%;
            clip-path: polygon(0% ${y}%, 100% ${y}%, 100% ${
              y + stripHeight
            }%, 0% ${y + stripHeight}%);
            transition: transform ${config.inDuration}ms ${
              config.easing.reveal
            };
          `;

          fragment.appendChild(bg);

          fragments.push({
            element: fragment,
            index: i,
            reveal: () => {
              fragment.style.transform = "translate3d(0, 0, 0) rotateX(0deg)";
            },
            collapse: () => {
              fragment.style.transform = "translate3d(0, 0, 0) rotateX(-90deg)";
            },
          });
        }

        return fragments;
      },
      revealTiming: (i, total) => Math.abs(i - total / 2) * 0.08,
      collapseTiming: (i) => i * 0.04,
    },

    liquid: {
      name: "Liquid Drops",
      create: (container, imageSrc, size) => {
        const fragments = [];
        const positions = [
          { x: 25, y: 20, r: 16 },
          { x: 70, y: 15, r: 12 },
          { x: 45, y: 35, r: 18 },
          { x: 15, y: 55, r: 14 },
          { x: 80, y: 45, r: 15 },
          { x: 55, y: 70, r: 20 },
          { x: 30, y: 80, r: 13 },
          { x: 75, y: 75, r: 17 },
        ];

        positions.forEach((pos, i) => {
          const fragment = document.createElement("div");
          fragment.className = "image-fragment";

          const bg = document.createElement("div");
          bg.className = "fragment-bg";
          bg.style.backgroundImage = `url(${imageSrc})`;

          fragment.style.cssText = `
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            clip-path: circle(0% at ${pos.x}% ${pos.y}%);
            transition: clip-path ${config.inDuration}ms ${config.easing.reveal};
          `;

          fragment.appendChild(bg);

          fragments.push({
            element: fragment,
            index: i,
            reveal: () => {
              fragment.style.clipPath = `circle(${pos.r}% at ${pos.x}% ${pos.y}%)`;
            },
            collapse: () => {
              fragment.style.clipPath = `circle(0% at ${pos.x}% ${pos.y}%)`;
            },
          });
        });

        return fragments;
      },
      revealTiming: (i, total) => (i / total) * 0.4,
      collapseTiming: (i, total) => ((total - 1 - i) / total) * 0.25,
    },

    curtain: {
      name: "Curtain Sweep",
      create: (container, imageSrc, size) => {
        const fragments = [];
        const stripCount = 10;

        for (let i = 0; i < stripCount; i++) {
          const fragment = document.createElement("div");
          fragment.className = "image-fragment";

          const bg = document.createElement("div");
          bg.className = "fragment-bg";
          bg.style.backgroundImage = `url(${imageSrc})`;

          const x = (i / stripCount) * 100;
          const w = 100 / stripCount;

          fragment.style.cssText = `
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            clip-path: polygon(${x + w / 2}% 0%, ${x + w / 2}% 0%, ${
              x + w / 2
            }% 100%, ${x + w / 2}% 100%);
            transition: clip-path ${config.inDuration}ms ${
              config.easing.reveal
            };
          `;

          fragment.appendChild(bg);

          fragments.push({
            element: fragment,
            index: i,
            reveal: () => {
              fragment.style.clipPath = `polygon(${x}% 0%, ${x + w}% 0%, ${
                x + w
              }% 100%, ${x}% 100%)`;
            },
            collapse: () => {
              fragment.style.clipPath = `polygon(${x + w / 2}% 0%, ${
                x + w / 2
              }% 0%, ${x + w / 2}% 100%, ${x + w / 2}% 100%)`;
            },
          });
        }

        return fragments;
      },
      revealTiming: (i, total) => (i / total) * 0.6,
      collapseTiming: (i, total) => ((total - 1 - i) / total) * 0.3,
    },

    hexagon: {
      name: "Hexagon Bloom",
      create: (container, imageSrc, size) => {
        const fragments = [];
        const hexagons = [
          { x: 50, y: 50, size: 20 },
          { x: 25, y: 25, size: 15 },
          { x: 75, y: 25, size: 15 },
          { x: 85, y: 50, size: 15 },
          { x: 75, y: 75, size: 15 },
          { x: 25, y: 75, size: 15 },
          { x: 15, y: 50, size: 15 },
        ];

        hexagons.forEach((hex, i) => {
          const fragment = document.createElement("div");
          fragment.className = "image-fragment";

          const bg = document.createElement("div");
          bg.className = "fragment-bg";
          bg.style.backgroundImage = `url(${imageSrc})`;

          const s = hex.size;
          const x = hex.x;
          const y = hex.y;

          const hexShape = `polygon(${x - s * 0.5}% ${y - s * 0.87}%, ${
            x + s * 0.5
          }% ${y - s * 0.87}%, ${x + s}% ${y}%, ${x + s * 0.5}% ${
            y + s * 0.87
          }%, ${x - s * 0.5}% ${y + s * 0.87}%, ${x - s}% ${y}%)`;

          fragment.style.cssText = `
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            clip-path: polygon(${x}% ${y}%, ${x}% ${y}%, ${x}% ${y}%);
            transition: clip-path ${config.inDuration}ms ${config.easing.reveal};
          `;

          fragment.appendChild(bg);

          fragments.push({
            element: fragment,
            index: i,
            reveal: () => {
              fragment.style.clipPath = hexShape;
            },
            collapse: () => {
              fragment.style.clipPath = `polygon(${x}% ${y}%, ${x}% ${y}%, ${x}% ${y}%)`;
            },
          });
        });

        return fragments;
      },
      revealTiming: (i) => (i === 0 ? 0 : 0.2 + (i - 1) * 0.06),
      collapseTiming: (i) => (i === 0 ? 0.3 : (i - 1) * 0.04),
    },

    zoomsplit: {
      name: "Zoom Split",
      create: (container, imageSrc, size) => {
        const fragments = [];
        const gridSize = 3;

        for (let row = 0; row < gridSize; row++) {
          for (let col = 0; col < gridSize; col++) {
            const fragment = document.createElement("div");
            fragment.className = "image-fragment";

            const bg = document.createElement("div");
            bg.className = "fragment-bg";
            bg.style.backgroundImage = `url(${imageSrc})`;

            const x = (col / gridSize) * 100;
            const y = (row / gridSize) * 100;
            const w = 100 / gridSize;
            const h = 100 / gridSize;

            fragment.style.cssText = `
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              clip-path: polygon(${x + w / 2}% ${y + h / 2}%, ${x + w / 2}% ${
                y + h / 2
              }%, ${x + w / 2}% ${y + h / 2}%, ${x + w / 2}% ${y + h / 2}%);
              transition: clip-path ${config.inDuration}ms ${
                config.easing.scale
              };
            `;

            fragment.appendChild(bg);

            fragments.push({
              element: fragment,
              index: row * gridSize + col,
              reveal: () => {
                fragment.style.clipPath = `polygon(${x}% ${y}%, ${
                  x + w
                }% ${y}%, ${x + w}% ${y + h}%, ${x}% ${y + h}%)`;
              },
              collapse: () => {
                fragment.style.clipPath = `polygon(${x + w / 2}% ${
                  y + h / 2
                }%, ${x + w / 2}% ${y + h / 2}%, ${x + w / 2}% ${y + h / 2}%, ${
                  x + w / 2
                }% ${y + h / 2}%)`;
              },
            });
          }
        }

        return fragments;
      },
      revealTiming: (i, total) => {
        const gridSize = Math.sqrt(total);
        const row = Math.floor(i / gridSize);
        const col = i % gridSize;
        const centerX = (gridSize - 1) / 2;
        const centerY = (gridSize - 1) / 2;
        const distance = Math.hypot(col - centerX, row - centerY);
        return distance * 0.15;
      },
      collapseTiming: (i, total) => {
        const gridSize = Math.sqrt(total);
        const row = Math.floor(i / gridSize);
        const col = i % gridSize;
        const centerX = (gridSize - 1) / 2;
        const centerY = (gridSize - 1) / 2;
        const distance = Math.hypot(col - centerX, row - centerY);
        return distance * 0.08;
      },
    },
  };

  const trail = [];
  let mouseX = 0;
  let mouseY = 0;
  let lastMouseX = 0;
  let lastMouseY = 0;
  let prevMouseX = 0;
  let prevMouseY = 0;

  let isMoving = false;
  let isCursorInContainer = false;
  let isTouching = false;

  let lastRemovalTime = 0;
  let lastTouchImageTime = 0;
  let lastScrollTime = 0;
  let lastMoveTime = Date.now();

  let isScrolling = false;
  let scrollTicking = false;
  let smoothedSpeed = 0;
  let maxSpeed = 0;
  let currentEffect = "zoomfade";
  let imageIndex = 0;

  const imagePool = [];

  const isInContainer = (x, y) => {
    const rect = container.getBoundingClientRect();
    return (
      x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom
    );
  };

  document.addEventListener("mouseover", function setInitialMousePos(e) {
    mouseX = lastMouseX = prevMouseX = e.clientX;
    mouseY = lastMouseY = prevMouseY = e.clientY;
    isCursorInContainer = isInContainer(mouseX, mouseY);
    document.removeEventListener("mouseover", setInitialMousePos);
  });

  const hasMovedEnough = () => {
    const dx = mouseX - lastMouseX;
    const dy = mouseY - lastMouseY;
    return Math.hypot(dx, dy) > config.mouseThreshold;
  };

  const hasMovedAtAll = () => {
    const dx = mouseX - prevMouseX;
    const dy = mouseY - prevMouseY;
    return Math.hypot(dx, dy) > config.minMovementForImage;
  };

  const calculateSpeed = () => {
    const now = Date.now();
    const dt = now - lastMoveTime;
    if (dt <= 0) return 0;

    const dist = Math.hypot(mouseX - prevMouseX, mouseY - prevMouseY);
    const raw = dist / dt;

    if (raw > maxSpeed) {
      maxSpeed = raw;
    }

    const norm = Math.min(raw / (maxSpeed || 0.5), 1);

    smoothedSpeed =
      smoothedSpeed * (1 - config.speedSmoothingFactor) +
      norm * config.speedSmoothingFactor;

    lastMoveTime = now;

    if (config.showSpeedIndicator && speedIndicator) {
      const effectName = PATTERNS[currentEffect].name;
      speedIndicator.textContent = `${effectName} Intensity: ${(
        smoothedSpeed * 100
      ).toFixed(0)}%`;
      speedIndicator.style.opacity = "1";

      clearTimeout(window.speedTimeout);
      window.speedTimeout = setTimeout(() => {
        speedIndicator.style.opacity = "0";
      }, 1500);
    }

    return smoothedSpeed;
  };

  const createImageElement = () => {
    if (imagePool.length > 0) {
      return imagePool.pop();
    }

    const element = document.createElement("div");
    element.className = "trail-image";
    return element;
  };

  const returnToPool = (element) => {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }

    element.innerHTML = "";
    element.style.cssText = "";
    element.className = "trail-image";

    if (imagePool.length < 20) {
      imagePool.push(element);
    }
  };

  const createImage = (speed = 0.5) => {
    const imageSrc = images[imageIndex];
    imageIndex = (imageIndex + 1) % images.length;

    const size =
      config.minImageSize + (config.maxImageSize - config.minImageSize) * speed;

    const pattern = PATTERNS[currentEffect];
    const rect = container.getBoundingClientRect();
    const x = mouseX - rect.left;
    const y = mouseY - rect.top;

    if (currentEffect === "flame" || currentEffect === "zoomfade") {
      const img = document.createElement("img");
      img.className = "trail-img";
      img.src = imageSrc;
      img.width = img.height = size;
      img.style.left = `${x}px`;
      img.style.top = `${y}px`;

      if (currentEffect === "flame") {
        const rotFactor = 1 + speed * (config.maxRotationFactor - 1);
        const rot = (Math.random() - 0.5) * config.baseRotation * rotFactor;

        img.style.transform = `translate(-50%, -50%) rotate(${rot}deg) scale(0)`;
        img.style.transition = `transform ${config.inDuration}ms ${config.inEasing}`;

        container.appendChild(img);

        setTimeout(() => {
          img.style.transform = `translate(-50%, -50%) rotate(${rot}deg) scale(1)`;
        }, 10);

        trail.push({
          element: img,
          rotation: rot,
          removeTime: Date.now() + config.imageLifespan,
          isFlame: true,
        });
      } else {
        img.style.opacity = "0";
        img.style.transform = "translate(-50%, -50%) scale(0.75)";
        img.style.transition = `transform ${config.inDuration}ms ease, opacity ${config.inDuration}ms ease`;

        container.appendChild(img);

        requestAnimationFrame(() => {
          img.style.opacity = "1";
          img.style.transform = "translate(-50%, -50%) scale(1)";
        });

        trail.push({
          element: img,
          removeTime: Date.now() + config.imageLifespan,
          isZoomFade: true,
        });
      }
    } else {
      const imageContainer = createImageElement();

      imageContainer.style.cssText = `
        left: ${x}px;
        top: ${y}px;
        width: ${size}px;
        height: ${size}px;
        transform: translate3d(-50%, -50%, 0) scale(0);
        transition: transform ${config.inDuration}ms ${config.easing.scale};
      `;

      const fragments = pattern.create(imageContainer, imageSrc, size);

      fragments.forEach((fragment) => {
        imageContainer.appendChild(fragment.element);
      });

      container.appendChild(imageContainer);

      requestAnimationFrame(() => {
        imageContainer.style.transform = "translate3d(-50%, -50%, 0) scale(1)";

        fragments.forEach((fragment) => {
          const revealTime = pattern.revealTiming(
            fragment.index,
            fragments.length,
            fragment,
          );
          const delay = revealTime * config.staggerRange;

          setTimeout(() => {
            fragment.reveal();
          }, delay);
        });
      });

      trail.push({
        element: imageContainer,
        fragments,
        pattern: currentEffect,
        removeTime: Date.now() + config.imageLifespan,
      });
    }
  };

  const createTrailImage = () => {
    if (!isCursorInContainer) return;

    if ((isMoving || isTouching) && hasMovedEnough() && hasMovedAtAll()) {
      lastMouseX = mouseX;
      lastMouseY = mouseY;

      const speed = calculateSpeed();
      createImage(speed);

      prevMouseX = mouseX;
      prevMouseY = mouseY;
    }
  };

  const createTouchTrailImage = () => {
    if (!isCursorInContainer || !isTouching || !hasMovedAtAll()) return;

    const now = Date.now();
    if (now - lastTouchImageTime < config.touchImageInterval) return;

    lastTouchImageTime = now;

    const speed = calculateSpeed();
    createImage(speed);

    prevMouseX = mouseX;
    prevMouseY = mouseY;
  };

  const createScrollTrailImage = () => {
    if (!isCursorInContainer || !isScrolling) return;

    lastMouseX += (config.mouseThreshold + 10) * (Math.random() > 0.5 ? 1 : -1);
    lastMouseY += (config.mouseThreshold + 10) * (Math.random() > 0.5 ? 1 : -1);

    createImage(0.5);

    lastMouseX = mouseX;
    lastMouseY = mouseY;
  };

  const removeOldImages = () => {
    const now = Date.now();

    if (now - lastRemovalTime < config.removalDelay || !trail.length) return;

    if (now >= trail[0].removeTime) {
      const imgObj = trail.shift();

      if (imgObj.isFlame) {
        imgObj.element.style.transition = `transform ${config.outDuration}ms ${config.outEasing}`;
        imgObj.element.style.transform = `translate(-50%, -50%) rotate(${
          imgObj.rotation + 360
        }deg) scale(0)`;

        setTimeout(() => {
          imgObj.element.remove();
        }, config.outDuration);
      } else if (imgObj.isZoomFade) {
        imgObj.element.style.transition = `transform ${config.outDuration}ms ease, opacity ${config.outDuration}ms ease`;
        imgObj.element.style.opacity = "0";
        imgObj.element.style.transform = "translate(-50%, -50%) scale(0.8)";

        setTimeout(() => {
          imgObj.element.remove();
        }, config.outDuration);
      } else {
        const { element, fragments, pattern: imagePattern } = imgObj;
        const pattern = PATTERNS[imagePattern];

        if (fragments) {
          fragments.forEach((fragment) => {
            const collapseTime = pattern.collapseTiming(
              fragment.index,
              fragments.length,
              fragment,
            );
            const delay = collapseTime * config.staggerRange;

            setTimeout(() => {
              fragment.collapse();
            }, delay);
          });
        }

        element.style.transition = `transform ${config.outDuration}ms ${config.outEasing}`;
        element.style.transform = "translate3d(-50%, -50%, 0) scale(0)";

        setTimeout(() => {
          returnToPool(element);
        }, config.outDuration);
      }

      lastRemovalTime = now;
    }
  };

  const effectLinks = document.querySelectorAll("[data-effect]");

  effectLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      effectLinks.forEach((l) => l.classList.remove("active"));
      link.classList.add("active");
      currentEffect = link.dataset.effect;
    });
  });

  document.addEventListener("mousemove", (e) => {
    prevMouseX = mouseX;
    prevMouseY = mouseY;

    mouseX = e.clientX;
    mouseY = e.clientY;

    isCursorInContainer = isInContainer(mouseX, mouseY);

    if (isCursorInContainer && hasMovedAtAll()) {
      isMoving = true;

      clearTimeout(window.moveTimeout);
      window.moveTimeout = setTimeout(() => {
        isMoving = false;
      }, 100);
    }
  });

  container.addEventListener("touchstart", (e) => {
    const touch = e.touches[0];

    prevMouseX = mouseX;
    prevMouseY = mouseY;
    mouseX = touch.clientX;
    mouseY = touch.clientY;
    lastMouseX = mouseX;
    lastMouseY = mouseY;
    isCursorInContainer = true;
    isTouching = true;
    lastMoveTime = Date.now();
  });

  container.addEventListener("touchmove", (e) => {
    const touch = e.touches[0];
    const dx = Math.abs(touch.clientX - prevMouseX);
    const dy = Math.abs(touch.clientY - prevMouseY);

    prevMouseX = mouseX;
    prevMouseY = mouseY;
    mouseX = touch.clientX;
    mouseY = touch.clientY;
    isCursorInContainer = true;

    if (dy > dx) return;

    createTouchTrailImage();
  });

  container.addEventListener("touchend", () => {
    isTouching = false;
  });

  document.addEventListener("touchstart", (e) => {
    const touch = e.touches[0];

    if (!isInContainer(touch.clientX, touch.clientY)) {
      isCursorInContainer = false;
      isTouching = false;
    }
  });

  window.addEventListener(
    "scroll",
    () => {
      isCursorInContainer = isInContainer(mouseX, mouseY);

      if (isCursorInContainer) {
        isScrolling = true;

        clearTimeout(window.scrollTimeout);
        window.scrollTimeout = setTimeout(() => {
          isScrolling = false;
        }, 100);
      }
    },
    { passive: true },
  );

  window.addEventListener(
    "scroll",
    () => {
      const now = Date.now();
      if (now - lastScrollTime < config.scrollThreshold) return;

      lastScrollTime = now;

      if (!scrollTicking && isCursorInContainer) {
        requestAnimationFrame(() => {
          if (isScrolling) {
            createScrollTrailImage();
          }
          scrollTicking = false;
        });

        scrollTicking = true;
      }
    },
    { passive: true },
  );

  (function animate() {
    if (isMoving || isTouching || isScrolling) {
      createTrailImage();
    }

    removeOldImages();
    requestAnimationFrame(animate);
  })();
});
